import {
  Component,
  ElementRef,
  HostListener,
  EventEmitter,
  Input,
  Output,
  OnInit,
  ChangeDetectionStrategy } from '@angular/core';

import {
  Router,
  NavigationExtras,
  ActivatedRoute } from '@angular/router';
  import { TranslateService } from '@ngx-translate/core';

import { FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import {Project, Partner, Country, User} from '../../../../../projectmanagement/src/app/model/project.model';

import * as projectforms from '../../../../../projectmanagement/src/app/forms/projectmanagement.form';
import { ProjectmanagementService } from '../../../../../projectmanagement/src/app/service/projectmanagement.service';

import { environment } from '../../../../../../src/environments/environment';

import {
  MyErrorHandler
} from '../../errorhandler/errorhandler';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  selector: 'app-ctl-partner-form',
  templateUrl: './CtlPartnerForm.html',
  styleUrls: ['./CtlPartnerForm.css'],
  providers: [ProjectmanagementService]
})

export class CtlPartnerForm implements OnInit {

  partnerForm = new FormGroup(projectforms.formPartner);

  partner_id: string;
  project_id: string;
  partnerType: string;
  logo_url: string;
  active: boolean;
  action: string;
  message: string;
  partnerStatus;
  @Input() type: string;
  @Input() partnerListData;
  @Input() pageTitle: string;
  newPartner = '';
  loggedInUser: any;
  environment;
  textDir:any;
  @Output() myFormChange: EventEmitter<boolean> = new EventEmitter();
  @Output() enableArchive: EventEmitter<any> = new EventEmitter();
  @Output() evEditEnable: EventEmitter<boolean> = new EventEmitter();
  // @Input() partnerData: any;

  constructor(
    private el: ElementRef,
    private _addnewprojectService: ProjectmanagementService,
    private router: Router,
    private translate:TranslateService,
    private route: ActivatedRoute) {
      this.textDir = sessionStorage.getItem('textDir');
     }

  ngOnInit() {
    // this.getPartnerList({});
    // this.partnerForm.reset();

    /*
    if (this.partnerForm.get('logo').value
      && this.partnerForm.get('logo').value.url) {
        this.logo_url = this.partnerForm.get('logo').value.url;
      }
      */
    const userData = JSON.parse(window.localStorage.getItem('loginInfoObj'));
    if (userData) {
      this.loggedInUser = userData;
    }
    //console.log("JANI User Info >>> "+JSON.stringify(this.loggedInUser));
    this.environment = environment;
    if (this.partnerForm.get('active').value) {
      this.partnerStatus = this.partnerForm.get('active').value;
    }
  }

  ngAfterViewInit() {
console.log("this.partnerForm");
console.log(this.partnerForm);
    this.partnerForm.valueChanges.subscribe(data =>   {
     
      this.myFormChange.emit(true);
    });

    //if(this.partnerForm.get('active').value) {
      //this.partnerStatus = this.partnerForm.get('active').value;
    //}
  }

  ngOnDestroy() {
  }
  log(data){
    console.log(data);
  }
  confirmEnableDisable(checkstatus) {
    this.enableArchive.emit(checkstatus);
  }

  myListFormatter(data: any): string {
    console.log('data ' + JSON.stringify(data));
    return data.name;
  }

  myValueFormatter(data: any): string {
    console.log('data ' + JSON.stringify(data));
    return data.name;
  }

  addPartner() {
   // console.log('Project Form Data ' + JSON.stringify(this.partnerForm.value));
    // redirect on success
    const data = this.partnerForm.value;

    if (this.project_id) {
      data.project_id = this.project_id;
      data.type = this.partnerType;
    }
    data.name = data.name.charAt(0).toUpperCase() + data.name.slice(1);

    this._addnewprojectService.addPartner(JSON.stringify(data)).subscribe(
      (response) => {
       // alert(' Full Response: ' + JSON.stringify(response));
       // this.newPartner =response.partner_id;
       // window.localStorage.setItem("newPartner",response.partner_id);
       this.newPartner = response.partner_id;
        /*
        const navigationExtras: NavigationExtras = {
          queryParams: {'partner_id': response.partner_id}
        };
        */
         this.message = this.translate.instant('Partner added sucessfully!');
         this.action = 'success';
         this.partnerForm.reset();
         this.myFormChange.emit(true);
      },
      (err) => {
        this.message = 'Failed to add partner, try again or contact administrator!';
        this.action = 'failure';
        this.myFormChange.emit(true);
        console.log('ERROR: ' + err );
      },
      () => {
       // console.log('COMPLETED');
      }

    );
  }
  removePhoto()
  {
    //alert("removePhoto called");
    let data = this.partnerForm.value;

    if (data.logo && data.logo.url) {
      //delete data.logo;
      this.logo_url = '';
      this.partnerForm.get('logo').patchValue({'url': null});
    }
  }
  updatePartner() {
    //console.log('Project Form Data ' + JSON.stringify(this.partnerForm.value));
    // redirect on success
    let data = this.partnerForm.value;
    if (this.project_id) {
      data.project_id = this.project_id;
      data.type = this.partnerType;
    }

    if (data.name && data.name._id) {
      data = data.name;
    }

    if ( data._id) {
      delete data._id;
    }

    this._addnewprojectService.editPartner(this.partner_id, JSON.stringify(data)).subscribe(
      (response) => {
       // console.log(' Full Response: ' + JSON.stringify(response));
        /*
        const navigationExtras: NavigationExtras = {
          queryParams: {'partner_id': response.partner_id}
        };
        */
         this.message = 'Partner updated sucessfully!';
         this.action = 'success';
         this.myFormChange.emit(true);
      },
      (err) => {
        this.message = 'Failed to update partner, try again or contact administrator!';
        this.action = 'failure';
        this.myFormChange.emit(true);
        console.log('ERROR: ' + err );
      },
      () => {
        //console.log('COMPLETED');
      }

    );
  }

  onPartnerFormSubmit() {
    if (this.partner_id) {
      this.updatePartner();
    } else {
      this.addPartner();
    }
  }

  resetForm() {
    this.partnerForm.reset();
  }

  partnerChanged(data: any) {
    console.log('data ' + JSON.stringify(data));
    if (data) {
      if (data._id) {
        this.partner_id = data._id;
        this.partnerForm.get('name').patchValue(data.name);
        this.partnerForm.get('url').patchValue(data.url);
        this.partnerForm.get('logo').patchValue(data.logo);
      }
    }
    this.myFormChange.emit(true);
  }

  formChanged(data) {
    this.myFormChange.emit(true);
  }

  enableDisablePartner(status) {
    if (status.checked === true) {
      this.disablePartner(this.partner_id);
    } else {
      this.enablePartner(this.partner_id);
    }
  }

  disablePartner(partner_id) {

    this._addnewprojectService.disablePartner(partner_id).subscribe(
        (response) => {
            //this.getProjectData(this.project_id);
        },
        (err) => {
          console.log('ERROR: ' + err);
          const errorHandlerObj = new MyErrorHandler();
          const errorHandler = errorHandlerObj.handleError(err);
          if (errorHandler.isSssionExpired) {
            this.router.navigate(['/login']);
            return true;
          }
        },
        () => {
          console.log('COMPLETED');
        }
    );
  }
  edit() {
    this.evEditEnable.emit(true);
  }

  enablePartner(partner_id) {

    this._addnewprojectService.enablePartner(partner_id).subscribe(
      (response) => {
        //this.getProjectData(this.project_id);
      },
      (err) => {
        console.log('ERROR: ' + err);
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        console.log('COMPLETED');
      }
    );
  }
}
